import { render, staticRenderFns } from "./EditTenantName.vue?vue&type=template&id=0d923a45"
import script from "./EditTenantName.vue?vue&type=script&lang=js"
export * from "./EditTenantName.vue?vue&type=script&lang=js"
import style0 from "./EditTenantName.vue?vue&type=style&index=0&id=0d923a45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports